import {TimelineSegmentProps} from '../timeline';

export const timelineItems: Array<TimelineSegmentProps> = [
  {
    title: 'We curate',
    description: `Our expert partners seek out rare or unique items with incredible stories.`,
  },
  {
    title: 'We fractionalise',
    description: `A trust is established with the beneficial interest split into a fixed number of fractions which we call ‘Pieces’.`,
  },
  {
    title: 'You benefit',
    description: `Own the unobtainable, pro-rata economic benefits and voting rights on any buyout offer plus item specific benefits.`,
  },
  {
    title: 'Buy & sell pieces',
    description: `Buy Pieces when they come live, and once the listing closes, sell pieces to other collectors via the Marketplace at a price of your choice.`,
  },
];

export const costs = [
  {
    content: `
    Showpieces are professionally stored by our partners
    `,
  },
  {
    content: `
    Fully insured against damage or theft
    `,
  },
];
